/**
 * 系统主题色
 */
export enum AppTheme {
    Default = 'default',
    Dark = 'dark',
    Light = 'light'
}